export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_REMINDER = 'OPEN_REMINDER';
export const CLOSE_REMINDER = 'CLOSE_REMINDER';
export const REMINDER_TIMED_OUT = 'REMINDER_TIMED_OUT';
export const SET_MODAL_TYPE = 'SET_MODAL_TYPE';
export const NEW_MODAL_OPEN = 'NEW_MODAL_OPEN';